// import { observable } from 'mobx'
import moment from 'moment'

import { eventExpirationTimeDays } from 'config'

// only need the actual tag names
function normalizeTags (tags) {
  return tags.map(tag => tag.name)
}

export default class StoryModel {
  id
  title
  content
  descMeta
  createdAt
  updatedAt
  image
  type
  tags
  // Events only
  eventDate
  endDate
  location

  constructor (obj) {
    // Assume creation from JSON AJAX call
    const normalizedObj = StoryModel.normalizeFromJS(obj)

    this.id = normalizedObj.id
    this.title = normalizedObj.title
    this.content = normalizedObj.content
    this.descMeta = normalizedObj.descMeta
    this.createdAt = normalizedObj.createdAt
    this.updatedAt = normalizedObj.updatedAt
    this.image = normalizedObj.image
    this.type = normalizedObj.type
    this.tags = normalizedObj.tags
    this.eventDate = normalizedObj.eventDate
    this.endDate = normalizedObj.endDate
    this.publishDate = normalizedObj.publishDate
    this.location = normalizedObj.location
  }

  static normalizeFromJS (obj) {
    const image = {
      main: obj.imageUrl,
      tile: obj.tileImageUrl,
      details: obj.imageUrl,
      width: parseInt(obj.image_width, 10) || 0,
      height: parseInt(obj.image_height, 10) || 0
    }

    const tags = normalizeTags(obj.storytags)

    return {
      id: obj.id,
      title: obj.title,
      content: obj.content,
      descMeta: obj.desc_meta,
      createdAt: obj.created_at,
      updatedAt: obj.updated_at,
      image,
      type: obj.story_type,
      tags,
      eventDate: obj.event_date,
      endDate: obj.end_date,
      publishDate: obj.publish_date,
      location: obj.location
    }
  }

  static ascendingDateComparator (storyA, storyB) {
    return storyA.actualEndDate - storyB.actualEndDate
  }

  static descendingDateComparator (storyA, storyB) {
    return storyB.actualEndDate - storyA.actualEndDate
  }

  /*
   * Alias title to complete (unofficial) document interface other models implement.
   */
  get name () {
    return this.title
  }
  get actualEndDate () {
    return new Date(this.endDate === '0000-00-00 00:00:00'
                    ? this.eventDate : this.endDate)
  }

  get expirationDate () {
    return moment(this.actualEndDate).add(eventExpirationTimeDays, 'day').toDate()
  }

  static fromJS (...args) {
    return new StoryModel(...args)
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/models/StoryModel.js